import { memo } from "react";
import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

interface PauseIconProps extends IconWrapperProps {
  color?: string;
}

const PauseIcon = ({ color, width, ...rest }: PauseIconProps) => (
  <IconWrapper viewBox="0 0 32 32" width={width || "32px"} {...rest}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color || "currentColor"}
        fillOpacity="0"
        d="M7 7H17V17H7z"
        transform="translate(-40 -957) translate(40 957)"
      />
      <path
        fill={color || "currentColor"}
        d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM9.333 7c.737 0 1.334.597 1.334 1.333v7.334c0 .736-.597 1.333-1.334 1.333C8.597 17 8 16.403 8 15.667V8.333C8 7.597 8.597 7 9.333 7zm5.334 0C15.403 7 16 7.597 16 8.333v7.334c0 .736-.597 1.333-1.333 1.333-.737 0-1.334-.597-1.334-1.333V8.333c0-.736.597-1.333 1.334-1.333z"
        transform="translate(-40 -957) translate(40 957)"
      />
    </g>
  </IconWrapper>
);

export default memo(PauseIcon);
